import { Box } from "@chakra-ui/react";
import Text from "./Text";

export const MultiLine = ({ line1, line2 }: { line1: string; line2: string }) => {
    if (!line1 && !line2) {
        return "-";
    };

    return (
        <Box>
            <Text>{line1}</Text>
            <Text variant="small" weight="semibold">{line2}</Text>
        </Box>
    )
}